import styled from 'styled-components';

import SearchResults from './SearchResults';

export default styled(SearchResults)`
  position: absolute;
  top: 4rem;
  right: 0;
  width: 17.6rem;
  background-color: var(--white);
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2);
  border-radius: 0.4rem;
  overflow: hidden;

  .search-results {
    &__loading {
      margin: 8px auto;
    }
  }
`;
